import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function BookingCancelledPage() {
  return (
    <div className="grain bg-[#050505] min-h-screen">
      <Nav />
      <main className="pt-32 md:pt-40 pb-24 min-h-[70vh]">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <div
            data-testid="booking-cancelled"
            className="border border-white/10 bg-white/[0.02] p-10 md:p-16"
          >
            <AlertCircle className="text-white/70 mb-6" size={40} strokeWidth={1.2} />
            <p className="eyebrow mb-3">Payment Cancelled</p>
            <h1 className="font-serif text-5xl md:text-7xl text-white leading-[0.95]">
              No worries, <span className="italic text-brand-red">we saved your spot.</span>
            </h1>
            <p className="mt-6 text-neutral-400 text-base md:text-lg leading-relaxed max-w-lg">
              You cancelled the deposit checkout — nothing was charged. Your
              booking wasn't finalised, so you'll need to submit again to secure
              your slot.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/#booking" className="btn-primary" data-testid="booking-cancelled-retry">
                Try Booking Again <ArrowRight size={14} />
              </Link>
              <a href="tel:0429052189" className="btn-ghost">
                Call SEVEN7H · 0429 052 189
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
